import type { EntityDataPubType, EntityPubType } from './entityBase';
import type { EntityDataPubType as EntityDataPubTypeAppsync } from '@/infra/appsync';

/**
 * Entityの抽象基底クラス.
 * 抽象クラスFactory/FactoryPubのみで使用します.
 */
export abstract class FactoryBase<E, P, J, PP, JP> {
  /**
   * Entityを生成する.
   * @param props props.
   * @returns Entity.
   */
  abstract create(props: P, propsPub: EntityPubType<PP>): E;

  /**
   * JSONからEntityを生成する.
   * @param props props.
   * @returns Entity.
   */
  abstract createFromJson(props: EntityDataPubType<J, JP>): E;

  /**
   * 並び順を決めます.
   */
  abstract compare: (a: EntityDataPubType<J, JP>, b: EntityDataPubType<J, JP>) => number;

  /**
   * EntityTypeからEntityを生成する.
   * @param props props.
   * @returns Entity.
   */
  createFromEntityType(props: EntityDataPubTypeAppsync): E {
    const data: EntityDataPubType<J, JP> = {

      data: JSON.parse(props.data),
      pub: props.pub ? {
        sendId: props.pub.sendId,
        replyId: props.pub.replyId,

        data: JSON.parse(props.pub.data),
      } : null,
    };
    return this.createFromJson(data);
  }
}
